import { useState, useCallback } from 'react';

export const UNIVERSAL_SEARCH_MAX_LEN = 500;

export function sanitizeUniversalSearchInput(raw) {
  return String(raw ?? '')
    .replace(/\0/g, '')
    .slice(0, UNIVERSAL_SEARCH_MAX_LEN);
}

export function useUniversalSearch() {
  const [universalSearchQuery, setUniversalSearchQueryRaw] = useState('');
  const [universalSearchDropdownOpen, setUniversalSearchDropdownOpen] = useState(false);

  const setUniversalSearchQuery = useCallback(
    (val) => setUniversalSearchQueryRaw(sanitizeUniversalSearchInput(val)),
    []
  );

  return {
    universalSearchQuery,
    setUniversalSearchQuery,
    universalSearchDropdownOpen,
    setUniversalSearchDropdownOpen,
  };
}
